import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            label_inicio: "Home",
            label_contacto: "Contact",
            label_iniciar_sesion: "Log in",
            label_plataforma_de_nutricion: "English for learners worldwide",
            label_ingresa_tus_credenciales_para_continuar: "Enter your credentials to continue",
            label_usuario: "Username",
            label_ingresa_tu_usuario: "Enter your username",
            label_contrasena: "Password",
            label_ingresa_tu_contrasena: "Enter your password",
            label_ingresar: "Sign in",
            label_volver_al_inicio: "Back to home",
            label_mi_perfil: "My profile",
            label_configuracion: "Settings",
            label_cerrar_sesion: "Log out",
            ct_header_greeting: "Hello, {{name}}",
            label_cargando: "Loading…",
            label_manage_applicant: "Manage applicants",
            label_administra_la_lista_de_applicants: "Administra la lista de applicants",
            label_nuevo: "New",
            label_buscar: "Search",
            label_estado: "Status",
            label_showing: "Showing",
            label_of: "of",
            label_records: "records",
            label_no_records: "No records",
            label_previous: "Previous",
            label_page: "Page",
            label_code: "Code",
            label_name: "Name",
            label_phone_number: "Phone number",
            label_email_address: "Email address",
            label_date_start: "Date start",
            label_expectation: "Expectation",
            label_modify_applicant: "Modify applicant",
            label_nombre_empresa: "Company name",
            label_nit_empresa: "NIT",
            label_telefono_empresa: "Phone number",
            info_telefono_empresa_whatsapp:
                "Enter your WhatsApp number including the country code (example: 59170000000).",
            label_info: "More information",
            label_direccion_empresa: "Address",
            label_confirmar_contrasena: "Confirm password",
            label_gestionar_sucursal: "Manage branch",
            label_administra_la_lista_de_sucursales: "Administra la lista de sucursales",
            label_color: "Color",
            label_seleccionar_color: "Select color",
            label_codigo: "Code",
            label_descripcion: "Description",
            label_nota: "Note",
            label_latitud: "Latitude",
            label_longitud: "Longitude",
            label_crear_sucursal: "Create branch",
            label_habilitado: "Enabled",
            label_deshabilitado: "Disabled",
            label_modificar_sucursal: "Modify branch",
            label_gestionar_categoria: "Manage category",
            label_administra_la_lista_de_categorias: "Manage the list of categories",
            label_crear_categoria: "Create category",
            label_modificar_categoria: "Modify category",
            label_gestionar_producto: "Manage product",
            label_administra_la_lista_de_productos: "Manage the list of products",
            label_crear_producto: "Create product",
            label_modificar_producto: "Modify product",
            label_nombre: "Name",
            label_slug: "Slug",
            label_moneda: "Currency",
            label_badge: "Badge",
            label_categoria: "Category",
            label_precio: "Price",
            label_precio_original: "Original price",
            label_porcentaje_descuento: "Discount %",
            label_rating: "Rating",
            label_cantidad_disponible_publico: "Public available quantity",
            label_cantidad_disponible_privado: "Private available quantity",
            label_publico: "Public",
            label_publico_si: "Public",
            label_publico_no: "Private",
            label_imagen_principal: "Main image",
            label_galeria_imagenes: "Image gallery",
            btn_imagenes_avanzado: "Advanced",
            btn_ocultar_imagenes_avanzado: "Hide advanced",
            label_imagenes_avanzado_hint: "Upload gallery images. Use Advanced to manage the main image separately.",
            label_imagenes_avanzado_activo: "Main image and gallery are available.",
            label_tipo_imagen_principal: "Main image type",
            label_tipo_imagenes: "Gallery image type",
            label_tipo_imagen_raster: "Image (PNG/JPG/JPEG)",
            label_tipo_imagen_svg: "SVG",
            label_seleccione_tipo_imagen: "Select an image type to continue.",
            label_seleccionar_imagen: "Select image",
            label_seleccionar_svg: "Select SVG",
            label_imagen_formatos_permitidos: "Allowed: PNG, JPG, JPEG",
            label_imagen_max_5mb: "Max size: 5 MB",
            label_svg_max_5mb: "Max SVG size: 5 MB",
            label_eliminar_imagen: "Remove image",
            label_eliminar: "Remove",
            label_arrastrar_imagen: "Drag and drop an image here",
            label_galeria_una_por_vez: "Upload one file at a time",
            label_galeria_max_imagenes: "Up to {{count}} images",
            label_agregar_svg: "Add SVG",
            placeholder_seleccione_moneda: "Select currency",
            placeholder_seleccione_categoria: "Select category",
            placeholder_seleccione_badge: "Select badge (optional)",
            placeholder_ingresa_nombre: "Enter name",
            placeholder_ingresa_slug: "Enter slug",
            alert_debe_seleccionar_categoria: "You must select a category",
            alert_debe_seleccionar_moneda: "You must select a currency",
            alert_debe_ingresar_nombre: "You must enter a name",
            alert_debe_ingresar_precio: "You must enter a price",
            alert_debe_agregar_al_menos_una_imagen: "You must add at least one gallery image",
            alert_imagen_excede_tamano: "File exceeds 5 MB",
            alert_imagen_formato_invalido: "Invalid image format. Use PNG, JPG or JPEG",
            alert_svg_formato_invalido: "Invalid SVG file",
            label_usado: "Used",
            label_popular: "Hot",

            alert_formato_color_invalido: "Invalid color format. Use #RGB or #RRGGBB.",
            alert_usuario_o_contrasena_incorrecto: "Incorrect username or password",
            alert_procesando_solicitud: "Processing…",
            alert_fecha_invalida: "Please enter a valid date.",
            alert_debe_ingresar_descripcion: "You must enter a description",


            cal_today: "Today",
            cal_placeholder_select: "Select date (MM-DD-YYYY)",

            menu_dashboard: "Dashboard",
            menu_administracion: "Management",
            menu_sucursales: "Branches",
            menu_salir: "Log out",
            menu_inventario: "Inventory",
            menu_listar_producto: "List product",
            menu_listar_categoria: "List category",

            te_brand: "Tutti English",
            te_nav_specialties: "Specialties",
            te_nav_accent: "Accent & speech",
            te_nav_how: "How it works",
            te_nav_join: "Register",
            te_hero_badge: "Kids, adults & professionals",
            te_hero_title: "Learn English —",
            te_hero_title_highlight: "clear accent, real confidence",
            te_hero_subtitle:
                "Online lessons tailored to how you speak today and how you want to sound tomorrow. Medical, tech, creative fields, and everyday fluency — with teachers who match your goals.",
            te_hero_cta_form: "Start with the form",
            te_hero_cta_whatsapp: "Chat on WhatsApp",
            te_hero_secondary: "Explore specialties",

            te_sectors_title: "English that fits your world",
            te_sectors_subtitle:
                "We pair you with teachers who know the vocabulary and scenarios you actually use — not only generic textbook English.",
            te_sector_medical_title: "Medical & healthcare",
            te_sector_medical_desc:
                "Pronunciation and technical language for consultations, charts, teamwork, and patient communication.",
            te_sector_it_title: "IT & engineering",
            te_sector_it_desc:
                "Stand-ups, documentation, interviews, and client calls — clear structure and natural pace.",
            te_sector_music_title: "Music & creative",
            te_sector_music_desc:
                "Studio talk, touring, interviews, and collaboration — expressive, accurate English for your craft.",

            te_accent_title: "Accent and the way you talk",
            te_accent_subtitle:
                "Whether you are starting out or polishing an advanced level, we focus on intelligibility, rhythm, and the sounds that matter for you — so you feel heard, not \"corrected\" into sounding unlike yourself.",
            te_accent_p1_title: "Sound natural",
            te_accent_p1_desc: "Stress, linking, and melody of English sentences in real conversations.",
            te_accent_p2_title: "Speak with ease",
            te_accent_p2_desc: "Breathing, pace, and confidence for calls, classes, and daily life.",
            te_accent_p3_title: "All ages welcome",
            te_accent_p3_desc: "Engaging paths for children and structured coaching for adults and teams.",

            te_steps_title: "How it works",
            te_steps_subtitle: "Simple steps from first hello to your first lesson.",
            te_step1_title: "Tell us about you",
            te_step1_desc: "Goals, level, schedule, and whether you care most about accent, exams, or work English.",
            te_step2_title: "We match a teacher",
            te_step2_desc: "Specialists for your field when it matters — always with a human, supportive style.",
            te_step3_title: "Learn live online",
            te_step3_desc: "Sessions that fit your time zone; practice you can use the same day.",

            te_enroll_title: "Ready to begin?",
            te_enroll_subtitle:
                "Answer a few questions in our form — level, goals, and availability. We read every response personally.",
            te_enroll_btn: "Open registration form",
            te_whatsapp_fab_aria: "Chat on WhatsApp",
            te_whatsapp_hint: "Prefer WhatsApp? Tap the green button anytime.",

            te_footer_line: "Tutti English — online English with heart and rigor.",
            te_footer_rights: "All rights reserved.",

            te_register_title: "Schedule your first class",
            te_register_subtitle:
                "Share a few details so we can get in touch with the best time for your trial lesson.",
            te_register_back: "Back to home",
            te_register_name: "Full name",
            te_register_name_ph: "Your name",
            te_register_phone: "Phone number",
            te_register_phone_ph: "Including country code if outside the US",
            te_register_email: "Email address",
            te_register_email_ph: "you@example.com",
            te_register_date: "When could you start?",
            te_register_date_help: "Pick the earliest date that works — we’ll confirm availability.",
            te_register_expectations: "What do you expect to learn?",
            te_register_expectations_ph:
                "e.g. conversational English, pronunciation, exams, workplace English…",
            te_register_submit: "Submit registration",
            te_register_validation: "Please fill in every field before submitting.",
            label_required_field: "This field is required.",
            te_char_count: "{{used}} / {{max}} characters · {{left}} remaining",
            te_register_success: "Thanks — we received your registration and will contact you soon.",
            te_register_failed: "Something went wrong. Please try again.",

            placeholder_select_status: "Select status",
            placeholder_input_code: "Enter code",
            placeholder_input_name: "Enter name",
            placeholder_input_phone_number: "Enter phone number",
            placeholder_input_email_address: "Enter email address",
            placeholder_input_date_start: "Enter date start",
            placeholder_input_expectation: "Enter expectation",
            placeholder_ingresa_codigo: "Enter code",
            placeholder_ingresa_descripcion: "Enter description",
            placeholder_ingresa_nota: "Enter note",
            placeholder_ingresa_latitud: "Enter latitude",
            placeholder_ingresa_longitud: "Enter longitude",
            placeholder_seleccione_estado: "Select status",

            column_code: "CODE",
            column_name: "NAME",
            column_phone_number: "PHONE NUMBER",
            column_email_address: "EMAIL ADDRESS",
            column_date_start: "DATE START",
            column_expectation: "EXPECTATION",
            column_enable: "ENABLE",
            column_enable_label: "ENABLE LABEL",
            column_date_process: "DATE PROCESS",
            column_enable_yes: "YES",
            column_enable_no: "NO",
            column_codigo: "CODE",
            column_descripcion: "DESCRIPTION",
            column_nota: "NOTE",
            column_estado: "STATUS",
            column_estado_label: "STATUS LABEL",
            column_color: "COLOR",
            column_fecha_proceso: "DATE PROCESS",
            column_nombre: "NAME",

            btn_modify: "Modify",
            btn_disable: "Disable",
            btn_enable: "Enable",
            btn_guardar: "Save",
            btn_cancelar: "Cancel",
            btn_modificar: "Modify",
            btn_deshabilitar: "Disable",
            btn_habilitar: "Enable",

            alert_proccesed_successfully: "Processed successfully",
            alert_process_failed: "Process failed",
            alert_are_you_sure_you_want_to_disable: "Are you sure you want to disable this applicant?",
            alert_are_you_sure_you_want_to_enable: "Are you sure you want to enable this applicant?",
            alert_disabled_successfully: "Disabled successfully",
            alert_enabled_successfully: "Enabled successfully",
            alert_no_se_pudo_crear: "Could not create",
            alert_no_se_pudo_modificar: "Could not modify",
            alert_se_creo_correctamente: "Created successfully",
            alert_se_modifico_correctamente: "Modified successfully",
            alert_esta_seguro_de_deshabilitar: "Are you sure you want to disable?",
            alert_esta_seguro_de_habilitar: "Are you sure you want to enable?",
            alert_passwords_no_coinciden: "Passwords do not match",
            alert_se_deshabilito_correctamente: "Disabled successfully",
            alert_se_habilito_correctamente: "Enabled successfully",

            dev_profile_badge: "Software development",
            dev_profile_role: "Software Developer",
            dev_profile_subtitle: "Custom software solutions for businesses and individuals worldwide.",
            dev_profile_about:
                "I build reliable web applications, internal tools, and digital products tailored to your goals — from idea to deployment and ongoing support.",
            dev_profile_services_title: "What I offer",
            dev_profile_service_1: "Web applications & dashboards",
            dev_profile_service_2: "APIs, integrations & automation",
            dev_profile_service_3: "Maintenance, updates & technical consulting",
            dev_profile_contact_title: "Contact",
            dev_profile_company_email: "Business email",
            dev_profile_email: "Email",
            dev_profile_phone: "Phone",
            dev_profile_address: "Address",
            dev_profile_zip: "Zip code",
            dev_profile_cta_email: "Send an email",
            dev_profile_cta_phone: "Call",
            dev_profile_back: "Back to home",

            ct_brand: "ComprarTodo",
            ct_nav_categories: "Categories",
            ct_nav_products: "Products",
            ct_hero_badge: "Everything. Everywhere. One marketplace.",
            ct_hero_title: "Buy anything —",
            ct_hero_title_highlight: "cars to plants, shoes to trucks",
            ct_hero_subtitle: "ComprarTodo is a wild, open marketplace. Browse cars, beauty, electronics, appliances, bikes, motorcycles, plants, fashion, and much more — then share any product with a single link.",
            ct_hero_cta_shop: "Shop now",
            ct_hero_cta_categories: "Browse categories",
            ct_hero_cta_sell: "Start selling",
            ct_hero_image_alt: "ComprarTodo marketplace preview",
            ct_hero_carousel_label: "Shop category",
            ct_hero_carousel_hint: "Tap to browse products in this category",
            ct_hero_carousel_dots: "Hero category carousel",
            ct_hero_stat_label: "Categories",
            ct_hero_stat_categories: "and growing",
            ct_categories_title: "Shop by category",
            ct_categories_subtitle: "From vehicles to houseplants — if it exists, you'll find it here.",
            ct_products_title: "Featured products",
            ct_products_filtered: "{{category}} picks",
            ct_products_subtitle: "Tap a product to see details or share it with friends.",
            ct_products_count: "{{count}} products",
            ct_products_empty: "No products in this category yet. Check back soon!",
            ct_view_details: "View details",
            ct_share: "Share",
            ct_share_product: "Share product",
            ct_share_facebook: "Share on Facebook",
            ct_share_whatsapp: "Share on WhatsApp",
            ct_share_twitter: "Share on X",
            ct_share_copy_link: "Copy link",
            ct_share_success: "Shared!",
            ct_share_copied: "Link copied!",
            ct_share_failed: "Could not share",
            ct_share_section_title: "Share products like Facebook",
            ct_share_section_subtitle: "Every product has a unique link with its UUID. Send it anywhere — the recipient lands on the product detail page.",
            ct_footer_line: "ComprarTodo — the marketplace where everything has a place.",
            ct_footer_categories_title: "Wild categories",
            ct_footer_categories_desc: "Cars, beauty, electronics, appliances, bicycles, motorcycles, trucks, plants, clothes, shoes, and more.",
            ct_footer_share_hint: "Share any product link with friends and family.",
            ct_badge_new: "New",
            ct_badge_hot: "Hot",
            ct_add_to_cart: "Add to cart",
            ct_share_link_label: "Shareable product link",
            ct_product_whatsapp: "WhatsApp",
            ct_product_whatsapp_message: "Hello, I'm interested in {{name}}: {{url}}",
            ct_share_link_hint: "Anyone with this link can view this product.",
            ct_related_products: "You may also like",
            ct_product_not_found: "Product not found",
            ct_product_not_found_desc: "This product link may be invalid or the item was removed.",
            ct_back: "Back",

            ct_category_all: "All",
            ct_category_cars: "Cars",
            ct_category_beauty: "Beauty",
            ct_category_electronics: "Electronics",
            ct_category_appliances: "Appliances",
            ct_category_bicycles: "Bicycles",
            ct_category_motorcycles: "Motorcycles",
            ct_category_vehicles: "Vehicles",
            ct_category_trucks: "Trucks",
            ct_category_plants: "Plants",
            ct_category_clothes: "Clothes",
            ct_category_shoes: "Shoes",
            ct_category_sports: "Sports",
            ct_category_home: "Home",
            ct_category_toys: "Toys",
            ct_category_pets: "Pets",
            ct_category_books: "Books",
            ct_category_jewelry: "Jewelry",
            ct_category_furniture: "Furniture",
            ct_category_tools: "Tools",
            ct_category_food: "Food",

            ct_product_tesla_name: "Electric Sedan Pro 2025",
            ct_product_tesla_desc: "Premium electric sedan with 400+ mile range, autopilot assist, and panoramic glass roof. Demo listing for the cars category.",
            ct_product_skincare_name: "Luxury Skincare Bundle",
            ct_product_skincare_desc: "Complete morning and night routine with serums, moisturizer, and SPF. Perfect for the beauty category showcase.",
            ct_product_laptop_name: "UltraBook Pro 16\"",
            ct_product_laptop_desc: "Powerful laptop with OLED display, 32GB RAM, and all-day battery. Electronics category flagship demo.",
            ct_product_fridge_name: "Smart French Door Fridge",
            ct_product_fridge_desc: "Energy-efficient refrigerator with touch display and dual cooling zones. Home appliances demo product.",
            ct_product_bike_name: "Carbon Trail Bike X1",
            ct_product_bike_desc: "Lightweight carbon frame mountain bike with hydraulic disc brakes. Built for adventure trails.",
            ct_product_motorcycle_name: "Street Cruiser 900",
            ct_product_motorcycle_desc: "Classic cruiser motorcycle with 900cc engine and leather saddle. Motorcycle category highlight.",
            ct_product_truck_name: "Heavy Duty Pickup 4x4",
            ct_product_truck_desc: "Full-size pickup truck with towing package and off-road suspension. Trucks category demo.",
            ct_product_plants_name: "Indoor Jungle Plant Set",
            ct_product_plants_desc: "Curated collection of low-maintenance indoor plants with ceramic pots. Plants category favorite.",
            ct_product_jacket_name: "All-Weather Jacket",
            ct_product_jacket_desc: "Waterproof breathable jacket for urban and outdoor wear. Fashion category staple.",
            ct_product_sneakers_name: "Air Sprint Runners",
            ct_product_sneakers_desc: "Lightweight running sneakers with responsive foam cushioning. Shoes category bestseller demo.",
            ct_product_suv_name: "Family Adventure SUV",
            ct_product_suv_desc: "Spacious 7-seat SUV with AWD, safety suite, and roof rails. Vehicles category demo listing.",
            ct_product_sofa_name: "Modular Lounge Sofa",
            ct_product_sofa_desc: "Comfortable modular sofa with washable covers and deep seating. Furniture category showcase.",

            ct_login_required_cart: "Please log in to add items to your cart…",
            ct_login_to_buy_hint: "Sign in to add this product to your cart and checkout.",
            ct_login_subtitle: "Sign in to buy, sell, and manage your ComprarTodo account.",
            ct_signup_title: "Create your account",
            ct_signup_subtitle: "Register your business and start selling on the marketplace.",
            ct_signup_step1: "Company info",
            ct_signup_step2: "Account",
            ct_signup_progress_label: "Registration progress",
            ct_signup_next: "Continue",
            ct_signup_back: "Back",
            ct_signup_register: "Register",
            ct_signup_have_account: "Already have an account?",
            ct_signup_no_account: "Don't have an account?",
            alert_empresa_registrada_correctamente: "Company registered successfully.",
            ct_added_to_cart: "Added to cart!",
            ct_price_label: "Special price",
            ct_price_sale_label: "Sale price",
            ct_price_was: "Was",
            ct_discount_off: "{{percent}}% off",
            ct_you_save: "You save",
            ct_trusted_rating: "trusted reviews",
            ct_more_photos: "photos",
            ct_my_account: "My account",
            ct_cart_items: "{{count}} items in cart",
            ct_no_images: "No images available",
            ct_gallery_prev: "Previous image",
            ct_gallery_next: "Next image",
            ct_gallery_go_to: "Go to image",
            ct_gallery_thumbnails: "Product photos",
            ct_angle_front: "Front view",
            ct_angle_side: "Side view",
            ct_angle_back: "Back view",
            ct_angle_detail: "Detail close-up",

            icon_all: "All",
            icon_food: "Food",
            icon_tools: "Tools",
            icon_furniture: "Furniture",
            icon_jewelry: "Jewelry",
            icon_pets: "Pets",
            icon_books: "Books",
            icon_toys: "Toys",
            icon_home: "Home",
            icon_sports: "Sports",
            icon_shoes: "Shoes",
            icon_clothes: "Clothes",
            icon_plants: "Plants",
            icon_trucks: "Trucks",
            icon_vehicles: "Vehicles",
            icon_motorcycles: "Motorcycles",
            icon_bicycles: "Bicycles",
            icon_appliances: "Appliances",
            icon_electronics: "Electronics",
            icon_beauty: "Beauty",
            icon_cars: "Cars",
        },
    },
    es: {
        translation: {
            label_inicio: "Inicio",
            label_contacto: "Contacto",
            label_iniciar_sesion: "Iniciar sesión",
            label_plataforma_de_nutricion: "Inglés para estudiantes de todo el mundo",
            label_ingresa_tus_credenciales_para_continuar: "Ingresa tus credenciales para continuar",
            label_usuario: "Usuario",
            label_ingresa_tu_usuario: "Ingresa tu usuario",
            label_contrasena: "Contraseña",
            label_ingresa_tu_contrasena: "Ingresa tu contraseña",
            label_ingresar: "Ingresar",
            label_volver_al_inicio: "Volver al inicio",
            label_mi_perfil: "Mi perfil",
            label_configuracion: "Configuración",
            label_cerrar_sesion: "Cerrar sesión",
            ct_header_greeting: "Hola, {{name}}",
            label_cargando: "Cargando…",
            label_manage_applicant: "Gestionar candidatos",
            label_administra_la_lista_de_applicants: "Administra la lista de candidatos",
            label_nuevo: "Nuevo",
            label_buscar: "Buscar",
            label_estado: "Estado",
            label_showing: "Mostrando",
            label_of: "de",
            label_records: "registros",
            label_no_records: "Sin registros",
            label_previous: "Anterior",
            label_page: "Página",
            label_code: "Código",
            label_name: "Nombre",
            label_phone_number: "Teléfono",
            label_email_address: "Correo electrónico",
            label_date_start: "Fecha de inicio",
            label_expectation: "Expectativa",
            label_modify_applicant: "Modificar candidato",
            label_nombre_empresa: "Nombre de la empresa",
            label_nit_empresa: "NIT",
            label_telefono_empresa: "Teléfono",
            info_telefono_empresa_whatsapp:
                "Ingresa tu número de WhatsApp incluyendo el código de país (ejemplo: 59170000000).",
            label_info: "Más información",
            label_direccion_empresa: "Dirección",
            label_confirmar_contrasena: "Confirmar contraseña",
            label_gestionar_sucursal: "Gestionar sucursal",
            label_administra_la_lista_de_sucursales: "Administra la lista de sucursales",
            label_color: "Color",
            label_seleccionar_color: "Seleccionar color",
            label_codigo: "Código",
            label_descripcion: "Descripción",
            label_nota: "Nota",
            label_latitud: "Latitud",
            label_longitud: "Longitud",
            label_crear_sucursal: "Crear sucursal",
            label_habilitado: "Habilitado",
            label_deshabilitado: "Deshabilitado",
            label_modificar_sucursal: "Modificar sucursal",
            label_gestionar_categoria: "Gestionar categoría",
            label_administra_la_lista_de_categorias: "Administra la lista de categorías",
            label_crear_categoria: "Crear categoría",
            label_modificar_categoria: "Modificar categoría",
            label_gestionar_producto: "Gestionar producto",
            label_administra_la_lista_de_productos: "Administra la lista de productos",
            label_crear_producto: "Crear producto",
            label_modificar_producto: "Modificar producto",
            label_nombre: "Nombre",
            label_slug: "Slug",
            label_moneda: "Moneda",
            label_badge: "Badge",
            label_categoria: "Categoría",
            label_precio: "Precio",
            label_precio_original: "Precio original",
            label_porcentaje_descuento: "Porcentaje descuento",
            label_rating: "Calificación",
            label_cantidad_disponible_publico: "Cantidad disponible público",
            label_cantidad_disponible_privado: "Cantidad disponible privado",
            label_publico: "Público",
            label_publico_si: "Público",
            label_publico_no: "Privado",
            label_imagen_principal: "Imagen principal",
            label_galeria_imagenes: "Galería de imágenes",
            btn_imagenes_avanzado: "Avanzado",
            btn_ocultar_imagenes_avanzado: "Ocultar avanzado",
            label_imagenes_avanzado_hint: "Sube imágenes de la galería. Usa Avanzado para gestionar la imagen principal por separado.",
            label_imagenes_avanzado_activo: "Imagen principal y galería disponibles.",
            label_tipo_imagen_principal: "Tipo imagen principal",
            label_tipo_imagenes: "Tipo imágenes galería",
            label_tipo_imagen_raster: "Imagen (PNG/JPG/JPEG)",
            label_tipo_imagen_svg: "SVG",
            label_seleccione_tipo_imagen: "Selecciona un tipo de imagen para continuar.",
            label_seleccionar_imagen: "Seleccionar imagen",
            label_seleccionar_svg: "Seleccionar SVG",
            label_imagen_formatos_permitidos: "Permitidos: PNG, JPG, JPEG",
            label_imagen_max_5mb: "Tamaño máximo: 5 MB",
            label_svg_max_5mb: "SVG máximo: 5 MB",
            label_eliminar_imagen: "Eliminar imagen",
            label_eliminar: "Eliminar",
            label_arrastrar_imagen: "Arrastra una imagen aquí",
            label_galeria_una_por_vez: "Sube un archivo a la vez",
            label_galeria_max_imagenes: "Hasta {{count}} imágenes",
            label_agregar_svg: "Agregar SVG",
            placeholder_seleccione_moneda: "Seleccione moneda",
            placeholder_seleccione_categoria: "Seleccione categoría",
            placeholder_seleccione_badge: "Seleccione badge (opcional)",
            placeholder_ingresa_nombre: "Ingresa el nombre",
            placeholder_ingresa_slug: "Ingresa el slug",
            alert_debe_seleccionar_categoria: "Debes seleccionar una categoría",
            alert_debe_seleccionar_moneda: "Debes seleccionar una moneda",
            alert_debe_ingresar_nombre: "Debes ingresar el nombre",
            alert_debe_ingresar_precio: "Debes ingresar el precio",
            alert_debe_agregar_al_menos_una_imagen: "Debes agregar al menos una imagen en la galería",
            alert_imagen_excede_tamano: "El archivo supera 5 MB",
            alert_imagen_formato_invalido: "Formato inválido. Usa PNG, JPG o JPEG",
            alert_svg_formato_invalido: "Archivo SVG inválido",
            label_usado: "Usado",
            label_popular: "Popular",

            alert_formato_color_invalido: "Formato de color inválido. Usa #RGB o #RRGGBB.",
            alert_usuario_o_contrasena_incorrecto: "Usuario o contraseña incorrectos",
            alert_procesando_solicitud: "Procesando…",
            alert_fecha_invalida: "Ingresa una fecha válida.",
            alert_debe_ingresar_descripcion: "Debes ingresar una descripción",

            cal_today: "Hoy",
            cal_placeholder_select: "Selecciona una fecha (MM-DD-YYYY)",

            menu_dashboard: "Panel",
            menu_administracion: "Administración",
            menu_sucursales: "Sucursales",
            menu_salir: "Salir",
            menu_inventario: "Inventario",
            menu_listar_producto: "Listar producto",
            menu_listar_categoria: "Listar categoría",

            te_brand: "Tutti English",
            te_nav_specialties: "Especialidades",
            te_nav_accent: "Acento y oralidad",
            te_nav_how: "Cómo funciona",
            te_nav_join: "Inscribirse",
            te_hero_badge: "Niños, adultos y profesionales",
            te_hero_title: "Aprende inglés —",
            te_hero_title_highlight: "acento claro, confianza real",
            te_hero_subtitle:
                "Clases en línea adaptadas a cómo hablas hoy y cómo quieres sonar mañana. Medicina, tecnología, arte y fluidez cotidiana — con docentes alineados a tus metas.",
            te_hero_cta_form: "Empezar con el formulario",
            te_hero_cta_whatsapp: "Escribir por WhatsApp",
            te_hero_secondary: "Ver especialidades",

            te_sectors_title: "Inglés que encaja en tu mundo",
            te_sectors_subtitle:
                "Te conectamos con profes que dominan el vocabulario y las situaciones que realmente usas — más allá del libro genérico.",
            te_sector_medical_title: "Medicina y salud",
            te_sector_medical_desc:
                "Pronunciación y lenguaje técnico para consultas, historias clínicas, equipo y comunicación con pacientes.",
            te_sector_it_title: "TI e ingeniería",
            te_sector_it_desc:
                "Dailies, documentación, entrevistas y llamadas con clientes — claridad y ritmo natural.",
            te_sector_music_title: "Música y creativos",
            te_sector_music_desc:
                "Estudio, giras, entrevistas y colaboración — inglés expresivo y preciso para tu oficio.",

            te_accent_title: "Acento y forma de hablar",
            te_accent_subtitle:
                "Si empiezas desde cero o quieres pulir un nivel avanzado, trabajamos inteligibilidad, ritmo y los sonidos que importan para ti — para que te sientas escuchado, no \"corregido\" hasta dejar de sonar como tú.",
            te_accent_p1_title: "Suena natural",
            te_accent_p1_desc: "Acento tónico, encadenado y melodía de frases en conversaciones reales.",
            te_accent_p2_title: "Habla con soltura",
            te_accent_p2_desc: "Respiración, velocidad y seguridad en llamadas, clases y vida diaria.",
            te_accent_p3_title: "Todas las edades",
            te_accent_p3_desc: "Rutas divertidas para niños y coaching estructurado para adultos y equipos.",

            te_steps_title: "Cómo funciona",
            te_steps_subtitle: "Pasos sencillos desde el primer hola hasta tu primera clase.",
            te_step1_title: "Cuéntanos de ti",
            te_step1_desc: "Metas, nivel, horario y si te importa más el acento, exámenes o inglés laboral.",
            te_step2_title: "Te asignamos un profe",
            te_step2_desc: "Especialistas en tu ámbito cuando hace falta — siempre con trato humano.",
            te_step3_title: "Aprende en vivo en línea",
            te_step3_desc: "Sesiones según tu zona horaria; práctica que puedes usar el mismo día.",

            te_enroll_title: "¿Listo para empezar?",
            te_enroll_subtitle:
                "Responde unas preguntas en nuestro formulario: nivel, objetivos y disponibilidad. Leemos cada mensaje.",
            te_enroll_btn: "Abrir formulario de inscripción",
            te_whatsapp_fab_aria: "Chatear por WhatsApp",
            te_whatsapp_hint: "¿Prefieres WhatsApp? Toca el botón verde cuando quieras.",

            te_footer_line: "Tutti English — inglés en línea con rigor y cercanía.",
            te_footer_rights: "Todos los derechos reservados.",

            te_register_title: "Agenda tu primera clase",
            te_register_subtitle:
                "Comparte algunos datos para contactarte con el mejor momento para tu clase de prueba.",
            te_register_back: "Volver al inicio",
            te_register_name: "Nombre completo",
            te_register_name_ph: "Tu nombre",
            te_register_phone: "Teléfono",
            te_register_phone_ph: "Con código de país si no estás en EE. UU.",
            te_register_email: "Correo electrónico",
            te_register_email_ph: "tu@ejemplo.com",
            te_register_date: "¿Cuándo podrías empezar?",
            te_register_date_help: "Elige la fecha más temprana que te funcione — confirmamos disponibilidad.",
            te_register_expectations: "¿Qué esperas aprender?",
            te_register_expectations_ph:
                "p. ej. inglés conversacional, pronunciación, exámenes, inglés laboral…",
            te_register_submit: "Enviar inscripción",
            te_register_validation: "Completa todos los campos antes de enviar.",
            label_required_field: "Este campo es obligatorio.",
            te_char_count: "{{used}} / {{max}} caracteres · {{left}} restantes",
            te_register_success: "Gracias — recibimos tu inscripción y te contactaremos pronto.",
            te_register_failed: "Algo salió mal. Inténtalo de nuevo.",

            placeholder_select_status: "Selecciona el estado",
            placeholder_input_code: "Ingresa el código",
            placeholder_input_name: "Ingresa el nombre",
            placeholder_input_phone_number: "Ingresa el número de teléfono",
            placeholder_input_email_address: "Ingresa el correo electrónico",
            placeholder_input_date_start: "Ingresa la fecha de inicio",
            placeholder_input_expectation: "Ingresa la expectativa",
            placeholder_ingresa_codigo: "Ingresa el código",
            placeholder_ingresa_descripcion: "Ingresa la descripción",
            placeholder_ingresa_nota: "Ingresa la nota",
            placeholder_ingresa_latitud: "Ingresa la latitud",
            placeholder_ingresa_longitud: "Ingresa la longitud",
            placeholder_seleccione_estado: "Selecciona el estado",

            column_code: "CODIGO",
            column_name: "NOMBRE",
            column_phone_number: "TELÉFONO",
            column_email_address: "CORREO ELECTRÓNICO",
            column_date_start: "FECHA DE INICIO",
            column_expectation: "EXPECTATIVA",
            column_enable: "HABILITADO",
            column_enable_label: "HABILITADO LABEL",
            column_date_process: "FECHA DE PROCESO",
            column_enable_yes: "SI",
            column_enable_no: "NO",
            column_codigo: "CÓDIGO",
            column_descripcion: "DESCRIPCIÓN",
            column_nota: "NOTA",
            column_estado: "ESTADO",
            column_estado_label: "ESTADO LABEL",
            column_color: "COLOR",
            column_fecha_proceso: "FECHA DE PROCESO",
            column_nombre: "NOMBRE",


            btn_guardar: "Guardar",
            btn_cancelar: "Cancelar",
            btn_modificar: "Modificar",
            btn_deshabilitar: "Deshabilitar",
            btn_habilitar: "Habilitar",

            alert_proccesed_successfully: "Procesado correctamente",
            alert_process_failed: "Procesado fallido",
            alert_are_you_sure_you_want_to_disable: "¿Estás seguro de querer deshabilitar este candidato?",
            alert_are_you_sure_you_want_to_enable: "¿Estás seguro de querer habilitar este candidato?",
            alert_disabled_successfully: "Deshabilitado correctamente",
            alert_enabled_successfully: "Habilitado correctamente",
            alert_no_se_pudo_crear: "No se pudo crear",
            alert_no_se_pudo_modificar: "No se pudo modificar",
            alert_se_creo_correctamente: "Creado correctamente",
            alert_se_modifico_correctamente: "Modificado correctamente",
            alert_esta_seguro_de_deshabilitar: "¿Estás seguro de querer deshabilitar?",
            alert_esta_seguro_de_habilitar: "¿Estás seguro de querer habilitar?",
            alert_passwords_no_coinciden: "Las contraseñas no coinciden",
            alert_se_deshabilito_correctamente: "Deshabilitado correctamente",
            alert_se_habilito_correctamente: "Habilitado correctamente",

            dev_profile_badge: "Desarrollo de software",
            dev_profile_role: "Desarrollador de software",
            dev_profile_subtitle: "Soluciones de software a medida para empresas y clientes de todo el mundo.",
            dev_profile_about:
                "Creo aplicaciones web, herramientas internas y productos digitales confiables — desde la idea hasta el despliegue y el soporte continuo.",
            dev_profile_services_title: "Servicios",
            dev_profile_service_1: "Aplicaciones web y paneles",
            dev_profile_service_2: "APIs, integraciones y automatización",
            dev_profile_service_3: "Mantenimiento, actualizaciones y consultoría técnica",
            dev_profile_contact_title: "Contacto",
            dev_profile_company_email: "Correo comercial",
            dev_profile_email: "Correo",
            dev_profile_phone: "Teléfono",
            dev_profile_address: "Dirección",
            dev_profile_zip: "Código postal",
            dev_profile_cta_email: "Enviar correo",
            dev_profile_cta_phone: "Llamar",
            dev_profile_back: "Volver al inicio",

            ct_brand: "ComprarTodo",
            ct_nav_categories: "Categorías",
            ct_nav_products: "Productos",
            ct_hero_badge: "Todo. En todas partes. Un solo marketplace.",
            ct_hero_title: "Compra lo que sea —",
            ct_hero_title_highlight: "de autos a plantas, de zapatos a camiones",
            ct_hero_subtitle: "ComprarTodo es un marketplace abierto y salvaje. Explora autos, belleza, electrónica, electrodomésticos, bicicletas, motos, plantas, moda y mucho más — y comparte cualquier producto con un enlace.",
            ct_hero_cta_shop: "Comprar ahora",
            ct_hero_cta_categories: "Ver categorías",
            ct_hero_cta_sell: "Empezar a vender",
            ct_hero_image_alt: "Vista previa del marketplace ComprarTodo",
            ct_hero_carousel_label: "Comprar categoría",
            ct_hero_carousel_hint: "Toca para ver productos de esta categoría",
            ct_hero_carousel_dots: "Carrusel de categorías",
            ct_hero_stat_label: "Categorías",
            ct_hero_stat_categories: "y creciendo",
            ct_categories_title: "Compra por categoría",
            ct_categories_subtitle: "Desde vehículos hasta plantas de interior — si existe, lo encuentras aquí.",
            ct_products_title: "Productos destacados",
            ct_products_filtered: "Selección de {{category}}",
            ct_products_subtitle: "Toca un producto para ver detalles o compartirlo con amigos.",
            ct_products_count: "{{count}} productos",
            ct_products_empty: "Aún no hay productos en esta categoría. ¡Vuelve pronto!",
            ct_view_details: "Ver detalles",
            ct_share: "Compartir",
            ct_share_product: "Compartir producto",
            ct_share_facebook: "Compartir en Facebook",
            ct_share_whatsapp: "Compartir en WhatsApp",
            ct_share_twitter: "Compartir en X",
            ct_share_copy_link: "Copiar enlace",
            ct_share_success: "¡Compartido!",
            ct_share_copied: "¡Enlace copiado!",
            ct_share_failed: "No se pudo compartir",
            ct_share_section_title: "Comparte productos como en Facebook",
            ct_share_section_subtitle: "Cada producto tiene un enlace único con su UUID. Envíalo a cualquier parte — quien lo abra verá la página de detalle del producto.",
            ct_footer_line: "ComprarTodo — el marketplace donde todo tiene su lugar.",
            ct_footer_categories_title: "Categorías salvajes",
            ct_footer_categories_desc: "Autos, belleza, electrónica, electrodomésticos, bicicletas, motos, camiones, plantas, ropa, zapatos y más.",
            ct_footer_share_hint: "Comparte cualquier enlace de producto con amigos y familia.",
            ct_badge_new: "Nuevo",
            ct_badge_hot: "Popular",
            ct_add_to_cart: "Agregar al carrito",
            ct_share_link_label: "Enlace compartible del producto",
            ct_product_whatsapp: "WhatsApp",
            ct_product_whatsapp_message: "Hola, me interesa {{name}}: {{url}}",
            ct_share_link_hint: "Cualquiera con este enlace puede ver este producto.",
            ct_related_products: "También te puede gustar",
            ct_product_not_found: "Producto no encontrado",
            ct_product_not_found_desc: "Este enlace puede ser inválido o el producto fue eliminado.",
            ct_back: "Volver",
            ct_category_all: "Todos",
            ct_category_cars: "Autos",
            ct_category_beauty: "Belleza",
            ct_category_electronics: "Electrónica",
            ct_category_appliances: "Electrodomésticos",
            ct_category_bicycles: "Bicicletas",
            ct_category_motorcycles: "Motos",
            ct_category_vehicles: "Vehículos",
            ct_category_trucks: "Camiones",
            ct_category_plants: "Plantas",
            ct_category_clothes: "Ropa",
            ct_category_shoes: "Zapatos",
            ct_category_sports: "Deportes",
            ct_category_home: "Hogar",
            ct_category_toys: "Juguetes",
            ct_category_pets: "Mascotas",
            ct_category_books: "Libros",
            ct_category_jewelry: "Joyería",
            ct_category_furniture: "Muebles",
            ct_category_tools: "Herramientas",
            ct_category_food: "Alimentos",
            ct_product_tesla_name: "Sedán Eléctrico Pro 2025",
            ct_product_tesla_desc: "Sedán eléctrico premium con más de 400 millas de autonomía, asistencia autopilot y techo panorámico. Demo de la categoría autos.",
            ct_product_skincare_name: "Set de Skincare de Lujo",
            ct_product_skincare_desc: "Rutina completa de mañana y noche con sueros, hidratante y SPF. Demo de la categoría belleza.",
            ct_product_laptop_name: "UltraBook Pro 16\"",
            ct_product_laptop_desc: "Laptop potente con pantalla OLED, 32GB RAM y batería de todo el día. Demo estrella de electrónica.",
            ct_product_fridge_name: "Refrigerador Smart French Door",
            ct_product_fridge_desc: "Refrigerador eficiente con pantalla táctil y zonas de enfriamiento dual. Demo de electrodomésticos.",
            ct_product_bike_name: "Bici Trail Carbono X1",
            ct_product_bike_desc: "Bicicleta de montaña con cuadro de carbono ligero y frenos de disco hidráulicos.",
            ct_product_motorcycle_name: "Cruiser Callejero 900",
            ct_product_motorcycle_desc: "Motocicleta cruiser clásica con motor 900cc y asiento de cuero. Destacado de motos.",
            ct_product_truck_name: "Pickup Heavy Duty 4x4",
            ct_product_truck_desc: "Camioneta full-size con paquete de remolque y suspensión off-road. Demo de camiones.",
            ct_product_plants_name: "Set Selva Interior",
            ct_product_plants_desc: "Colección de plantas de interior de bajo mantenimiento con macetas de cerámica.",
            ct_product_jacket_name: "Chaqueta Todo Clima",
            ct_product_jacket_desc: "Chaqueta impermeable y transpirable para uso urbano y outdoor. Básico de moda.",
            ct_product_sneakers_name: "Air Sprint Runners",
            ct_product_sneakers_desc: "Zapatillas ligeras para correr con amortiguación responsive. Demo bestseller de zapatos.",
            ct_product_suv_name: "SUV Aventura Familiar",
            ct_product_suv_desc: "SUV espacioso de 7 asientos con AWD, suite de seguridad y rieles de techo.",
            ct_product_sofa_name: "Sofá Modular Lounge",
            ct_product_sofa_desc: "Sofá modular cómodo con fundas lavables y asiento profundo. Demo de muebles.",

            ct_login_required_cart: "Inicia sesión para agregar al carrito…",
            ct_login_to_buy_hint: "Inicia sesión para agregar este producto al carrito y comprar.",
            ct_login_subtitle: "Inicia sesión para comprar, vender y administrar tu cuenta ComprarTodo.",
            ct_signup_title: "Crea tu cuenta",
            ct_signup_subtitle: "Registra tu negocio y empieza a vender en el marketplace.",
            ct_signup_step1: "Datos de empresa",
            ct_signup_step2: "Cuenta",
            ct_signup_progress_label: "Progreso del registro",
            ct_signup_next: "Continuar",
            ct_signup_back: "Atrás",
            ct_signup_register: "Registrar",
            ct_signup_have_account: "¿Ya tienes cuenta?",
            ct_signup_no_account: "¿No tienes cuenta?",
            alert_empresa_registrada_correctamente: "Empresa registrada correctamente.",
            ct_added_to_cart: "¡Agregado al carrito!",
            ct_price_label: "Precio especial",
            ct_price_sale_label: "Precio de oferta",
            ct_price_was: "Antes",
            ct_discount_off: "{{percent}}% dto.",
            ct_you_save: "Ahorras",
            ct_trusted_rating: "reseñas verificadas",
            ct_more_photos: "fotos",
            ct_my_account: "Mi cuenta",
            ct_cart_items: "{{count}} artículos en el carrito",
            ct_no_images: "Sin imágenes disponibles",
            ct_gallery_prev: "Imagen anterior",
            ct_gallery_next: "Imagen siguiente",
            ct_gallery_go_to: "Ir a imagen",
            ct_gallery_thumbnails: "Fotos del producto",
            ct_angle_front: "Vista frontal",
            ct_angle_side: "Vista lateral",
            ct_angle_back: "Vista trasera",
            ct_angle_detail: "Detalle",

            icon_all: "Todo",
            icon_food: "Alimentos",
            icon_tools: "Herramientas",
            icon_furniture: "Muebles",
            icon_jewelry: "Joyería",
            icon_pets: "Mascotas",
            icon_books: "Libros",
            icon_toys: "Juguetes",
            icon_home: "Hogar",
            icon_sports: "Deportes",
            icon_shoes: "Zapatos",
            icon_clothes: "Ropa",
            icon_plants: "Plantas",
            icon_trucks: "Camiones",
            icon_vehicles: "Vehículos",
            icon_motorcycles: "Motos",
            icon_bicycles: "Bicicletas",
            icon_appliances: "Electrodomésticos",
            icon_electronics: "Electrónica",
            icon_beauty: "Belleza",
            icon_cars: "Autos",
        },
    },
    pt: {
        translation: {
            label_inicio: "Início",
            label_contacto: "Contato",
            label_iniciar_sesion: "Entrar",
            label_plataforma_de_nutricion: "Inglês para alunos em todo o mundo",
            label_ingresa_tus_credenciales_para_continuar: "Insira suas credenciais para continuar",
            label_usuario: "Usuário",
            label_ingresa_tu_usuario: "Digite seu usuário",
            label_contrasena: "Senha",
            label_ingresa_tu_contrasena: "Digite sua senha",
            label_ingresar: "Entrar",
            label_volver_al_inicio: "Voltar ao início",
            label_mi_perfil: "Meu perfil",
            label_configuracion: "Configurações",
            label_cerrar_sesion: "Sair",
            ct_header_greeting: "Olá, {{name}}",
            label_cargando: "Carregando…",
            label_manage_applicant: "Gerenciar candidatos",
            label_administra_la_lista_de_applicants: "Administra a lista de candidatos",
            label_nuevo: "Nuevo",
            label_buscar: "Buscar",
            label_estado: "Estado",
            label_showing: "Mostrando",
            label_of: "de",
            label_records: "registros",
            label_no_records: "Sin registros",
            label_previous: "Anterior",
            label_page: "Página",
            label_code: "Código",
            label_name: "Nome",
            label_phone_number: "Número de telefone",
            label_email_address: "Endereço de e-mail",
            label_date_start: "Data de início",
            label_expectation: "Expectativa",
            label_modify_applicant: "Modificar candidato",
            label_nombre_empresa: "Nome da empresa",
            label_nit_empresa: "NIT",
            label_telefono_empresa: "Número de telefone",
            info_telefono_empresa_whatsapp:
                "Informe seu número de WhatsApp incluindo o código do país (exemplo: 59170000000).",
            label_info: "Mais informações",
            label_direccion_empresa: "Endereço",
            label_confirmar_contrasena: "Confirmar senha",
            label_gestionar_sucursal: "Gerenciar sucursal",
            label_administra_la_lista_de_sucursales: "Administra a lista de sucursales",
            label_color: "Cor",
            label_seleccionar_color: "Selecionar cor",
            label_codigo: "Código",
            label_descripcion: "Descrição",
            label_nota: "Nota",
            label_latitud: "Latitude",
            label_longitud: "Longitude",
            label_crear_sucursal: "Criar sucursal",
            label_habilitado: "Habilitado",
            label_deshabilitado: "Deshabilitado",
            label_modificar_sucursal: "Modificar sucursal",
            label_gestionar_categoria: "Gerenciar categoría",
            label_administra_la_lista_de_categorias: "Administra a lista de categorías",
            label_crear_categoria: "Criar categoría",
            label_modificar_categoria: "Modificar categoría",
            label_gestionar_producto: "Gerenciar producto",
            label_administra_la_lista_de_productos: "Administra a lista de productos",
            label_crear_producto: "Criar producto",
            label_modificar_producto: "Modificar producto",
            label_nombre: "Nome",
            label_slug: "Slug",
            label_moneda: "Moeda",
            label_badge: "Badge",
            label_categoria: "Categoria",
            label_precio: "Preço",
            label_precio_original: "Preço original",
            label_porcentaje_descuento: "Percentual de desconto",
            label_rating: "Avaliação",
            label_cantidad_disponible_publico: "Quantidade disponível pública",
            label_cantidad_disponible_privado: "Quantidade disponível privada",
            label_publico: "Público",
            label_publico_si: "Público",
            label_publico_no: "Privado",
            label_imagen_principal: "Imagem principal",
            label_galeria_imagenes: "Galeria de imagens",
            btn_imagenes_avanzado: "Avançado",
            btn_ocultar_imagenes_avanzado: "Ocultar avançado",
            label_imagenes_avanzado_hint: "Envie imagens da galeria. Use Avançado para gerenciar a imagem principal separadamente.",
            label_imagenes_avanzado_activo: "Imagem principal e galeria disponíveis.",
            label_tipo_imagen_principal: "Tipo da imagem principal",
            label_tipo_imagenes: "Tipo das imagens da galeria",
            label_tipo_imagen_raster: "Imagem (PNG/JPG/JPEG)",
            label_tipo_imagen_svg: "SVG",
            label_seleccione_tipo_imagen: "Selecione um tipo de imagem para continuar.",
            label_seleccionar_imagen: "Selecionar imagem",
            label_seleccionar_svg: "Selecionar SVG",
            label_imagen_formatos_permitidos: "Permitidos: PNG, JPG, JPEG",
            label_imagen_max_5mb: "Tamanho máximo: 5 MB",
            label_svg_max_5mb: "SVG máximo: 5 MB",
            label_eliminar_imagen: "Remover imagem",
            label_eliminar: "Remover",
            label_arrastrar_imagen: "Arraste uma imagem aqui",
            label_galeria_una_por_vez: "Envie um arquivo por vez",
            label_galeria_max_imagenes: "Até {{count}} imagens",
            label_agregar_svg: "Adicionar SVG",
            placeholder_seleccione_moneda: "Selecione a moeda",
            placeholder_seleccione_categoria: "Selecione a categoria",
            placeholder_seleccione_badge: "Selecione badge (opcional)",
            placeholder_ingresa_nombre: "Digite o nome",
            placeholder_ingresa_slug: "Digite o slug",
            alert_debe_seleccionar_categoria: "Você deve selecionar uma categoria",
            alert_debe_seleccionar_moneda: "Você deve selecionar uma moeda",
            alert_debe_ingresar_nombre: "Você deve inserir o nome",
            alert_debe_ingresar_precio: "Você deve inserir o preço",
            alert_debe_agregar_al_menos_una_imagen: "Você deve adicionar pelo menos uma imagem na galeria",
            alert_imagen_excede_tamano: "O arquivo excede 5 MB",
            alert_imagen_formato_invalido: "Formato inválido. Use PNG, JPG ou JPEG",
            alert_svg_formato_invalido: "Arquivo SVG inválido",
            label_usado: "Usado",
            label_popular: "Popular",

            alert_formato_color_invalido: "Formato de cor inválido. Use #RGB ou #RRGGBB.",

            alert_usuario_o_contrasena_incorrecto: "Usuário ou senha incorretos",
            alert_procesando_solicitud: "Processando…",
            alert_fecha_invalida: "Insira uma data válida.",
            alert_debe_ingresar_descripcion: "Você deve inserir uma descrição",

            cal_today: "Hoje",
            cal_placeholder_select: "Selecione a data (MM-DD-YYYY)",

            menu_dashboard: "Painel",
            menu_administracion: "Administração",
            menu_sucursales: "Sucursales",
            menu_salir: "Sair",
            menu_inventario: "Inventario",
            menu_listar_producto: "Listar producto",
            menu_listar_categoria: "Listar categoría",

            te_brand: "Tutti English",
            te_nav_specialties: "Especialidades",
            te_nav_accent: "Sotaque e fala",
            te_nav_how: "Como funciona",
            te_nav_join: "Inscrever-se",
            te_hero_badge: "Crianças, adultos e profissionais",
            te_hero_title: "Aprenda inglês —",
            te_hero_title_highlight: "sotaque claro, confiança de verdade",
            te_hero_subtitle:
                "Aulas online sob medida para como você fala hoje e como quer soar amanhã. Saúde, tecnologia, arte e fluência do dia a dia — com professores alinhados aos seus objetivos.",
            te_hero_cta_form: "Começar pelo formulário",
            te_hero_cta_whatsapp: "Falar no WhatsApp",
            te_hero_secondary: "Ver especialidades",

            te_sectors_title: "Inglês que combina com o seu mundo",
            te_sectors_subtitle:
                "Conectamos você a professores que dominam o vocabulário e os cenários que você realmente usa — além do livro genérico.",
            te_sector_medical_title: "Medicina e saúde",
            te_sector_medical_desc:
                "Pronúncia e linguagem técnica para consultas, prontuários, equipe e comunicação com pacientes.",
            te_sector_it_title: "TI e engenharia",
            te_sector_it_desc:
                "Dailies, documentação, entrevistas e calls com clientes — clareza e ritmo naturais.",
            te_sector_music_title: "Música e criativos",
            te_sector_music_desc:
                "Estúdio, turnês, entrevistas e parcerias — inglês expressivo e preciso para o seu ofício.",

            te_accent_title: "Sotaque e jeito de falar",
            te_accent_subtitle:
                "Do iniciante ao avançado, focamos inteligibilidade, ritmo e os sons que importam para você — para que se sinta ouvido, não \"corrigido\" até deixar de soar como você.",
            te_accent_p1_title: "Soar natural",
            te_accent_p1_desc: "Ênfase, conexão e melodia de frases em conversas reais.",
            te_accent_p2_title: "Falar com leveza",
            te_accent_p2_desc: "Respiração, velocidade e segurança em chamadas, aulas e vida diária.",
            te_accent_p3_title: "Todas as idades",
            te_accent_p3_desc: "Trilhas lúdicas para crianças e coaching estruturado para adultos e equipes.",

            te_steps_title: "Como funciona",
            te_steps_subtitle: "Passos simples do primeiro oi até a sua primeira aula.",
            te_step1_title: "Conte sobre você",
            te_step1_desc: "Metas, nível, agenda e se o foco é sotaque, provas ou inglês profissional.",
            te_step2_title: "Combinamos um professor",
            te_step2_desc: "Especialistas da sua área quando importa — sempre com acolhimento humano.",
            te_step3_title: "Aprenda ao vivo online",
            te_step3_desc: "Horários no seu fuso; prática que você usa no mesmo dia.",

            te_enroll_title: "Pronto para começar?",
            te_enroll_subtitle:
                "Responda a um breve formulário: nível, objetivos e disponibilidade. Lemos cada resposta com atenção.",
            te_enroll_btn: "Abrir formulário de inscrição",
            te_whatsapp_fab_aria: "Conversar no WhatsApp",
            te_whatsapp_hint: "Prefere WhatsApp? Toque no botão verde quando quiser.",

            te_footer_line: "Tutti English — inglês online com rigor e afeto.",
            te_footer_rights: "Todos os direitos reservados.",

            te_register_title: "Agende sua primeira aula",
            te_register_subtitle:
                "Envie alguns dados para combinarmos o melhor horário para sua aula experimental.",
            te_register_back: "Voltar ao início",
            te_register_name: "Nome completo",
            te_register_name_ph: "Seu nome",
            te_register_phone: "Telefone",
            te_register_phone_ph: "Inclua código do país se não estiver nos EUA",
            te_register_email: "E-mail",
            te_register_email_ph: "voce@exemplo.com",
            te_register_date: "Quando você poderia começar?",
            te_register_date_help: "Escolha a data mais cedo que funcione para você — confirmamos a disponibilidade.",
            te_register_expectations: "O que você espera aprender?",
            te_register_expectations_ph:
                "ex.: inglês conversacional, pronúncia, provas, inglês corporativo…",
            te_register_submit: "Enviar inscrição",
            te_register_validation: "Preencha todos os campos antes de enviar.",
            label_required_field: "Este campo é obrigatório.",
            te_char_count: "{{used}} / {{max}} caracteres · {{left}} restantes",
            te_register_success: "Obrigado — recebemos sua inscrição e entraremos em contato em breve.",
            te_register_failed: "Algo deu errado. Tente novamente.",

            placeholder_select_status: "Selecione o estado",
            placeholder_input_code: "Digite o código",
            placeholder_input_name: "Digite o nome",
            placeholder_input_phone_number: "Digite o número de telefone",
            placeholder_input_email_address: "Digite o endereço de e-mail",
            placeholder_input_date_start: "Digite a data de início",
            placeholder_input_expectation: "Digite a expectativa",
            placeholder_ingresa_codigo: "Digite o código",
            placeholder_ingresa_descripcion: "Digite a descrição",
            placeholder_ingresa_nota: "Digite a nota",
            placeholder_ingresa_latitud: "Digite a latitude",
            placeholder_ingresa_longitud: "Digite a longitude",
            placeholder_seleccione_estado: "Selecione o estado",

            column_code: "CÓDIGO",
            column_name: "NOME",
            column_phone_number: "TELEFONE",
            column_email_address: "E-MAIL",
            column_date_start: "DATA DE INICIO",
            column_expectation: "EXPECTATIVA",
            column_enable: "HABILITADO",
            column_enable_label: "HABILITADO LABEL",
            column_date_process: "DATA DE PROCESO",
            column_enable_yes: "SIM",
            column_enable_no: "NÃO",
            column_codigo: "CÓDIGO",
            column_descripcion: "DESCRIPCIÓN",
            column_nota: "NOTA",
            column_estado: "ESTADO",
            column_estado_label: "ESTADO LABEL",
            column_color: "COLOR",
            column_fecha_proceso: "FECHA DE PROCESO",
            column_nombre: "NOMBRE",


            btn_guardar: "Salvar",
            btn_cancelar: "Cancelar",
            btn_modificar: "Modificar",
            btn_deshabilitar: "Deshabilitar",
            btn_habilitar: "Habilitar",

            alert_proccesed_successfully: "Procesado correctamente",
            alert_process_failed: "Procesado fallido",
            alert_are_you_sure_you_want_to_disable: "¿Estás seguro de querer deshabilitar este candidato?",
            alert_are_you_sure_you_want_to_enable: "¿Estás seguro de querer habilitar este candidato?",
            alert_disabled_successfully: "Deshabilitado correctamente",
            alert_enabled_successfully: "Habilitado correctamente",
            alert_no_se_pudo_crear: "No se pudo crear",
            alert_no_se_pudo_modificar: "No se pudo modificar",
            alert_se_creo_correctamente: "Criado correctamente",
            alert_se_modifico_correctamente: "Modificado com sucesso",
            alert_esta_seguro_de_deshabilitar: "Estás seguro de querer deshabilitar?",
            alert_esta_seguro_de_habilitar: "Estás seguro de querer habilitar?",
            alert_passwords_no_coinciden: "Las contraseñas no coinciden",
            alert_se_deshabilito_correctamente: "Se deshabilitó correctamente",
            alert_se_habilito_correctamente: "Se habilitó correctamente",

            dev_profile_badge: "Desenvolvimento de software",
            dev_profile_role: "Desenvolvedor de software",
            dev_profile_subtitle: "Soluções de software sob medida para empresas e clientes em todo o mundo.",
            dev_profile_about:
                "Desenvolvo aplicações web, ferramentas internas e produtos digitais confiáveis — da ideia à implantação e suporte contínuo.",
            dev_profile_services_title: "Serviços",
            dev_profile_service_1: "Aplicações web e painéis",
            dev_profile_service_2: "APIs, integrações e automação",
            dev_profile_service_3: "Manutenção, atualizações e consultoria técnica",
            dev_profile_contact_title: "Contato",
            dev_profile_company_email: "E-mail comercial",
            dev_profile_email: "E-mail",
            dev_profile_phone: "Telefone",
            dev_profile_address: "Endereço",
            dev_profile_zip: "CEP",
            dev_profile_cta_email: "Enviar e-mail",
            dev_profile_cta_phone: "Ligar",
            dev_profile_back: "Voltar ao início",

            ct_brand: "ComprarTodo",
            ct_nav_categories: "Categorias",
            ct_nav_products: "Produtos",
            ct_hero_badge: "Tudo. Em todo lugar. Um marketplace.",
            ct_hero_title: "Compre qualquer coisa —",
            ct_hero_title_highlight: "de carros a plantas, de sapatos a caminhões",
            ct_hero_subtitle: "ComprarTodo é um marketplace aberto e ousado. Explore carros, beleza, eletrônicos, eletrodomésticos, bicicletas, motos, plantas, moda e muito mais — e compartilhe qualquer produto com um link.",
            ct_hero_cta_shop: "Comprar agora",
            ct_hero_cta_categories: "Ver categorias",
            ct_hero_cta_sell: "Começar a vender",
            ct_hero_image_alt: "Prévia do marketplace ComprarTodo",
            ct_hero_carousel_label: "Comprar categoria",
            ct_hero_carousel_hint: "Toque para ver produtos desta categoria",
            ct_hero_carousel_dots: "Carrossel de categorias",
            ct_hero_stat_label: "Categorias",
            ct_hero_stat_categories: "e crescendo",
            ct_categories_title: "Compre por categoria",
            ct_categories_subtitle: "De veículos a plantas de interior — se existe, você encontra aqui.",
            ct_products_title: "Produtos em destaque",
            ct_products_filtered: "Seleção de {{category}}",
            ct_products_subtitle: "Toque em um produto para ver detalhes ou compartilhar com amigos.",
            ct_products_count: "{{count}} produtos",
            ct_products_empty: "Ainda não há produtos nesta categoria. Volte em breve!",
            ct_view_details: "Ver detalhes",
            ct_share: "Compartilhar",
            ct_share_product: "Compartilhar produto",
            ct_share_facebook: "Compartilhar no Facebook",
            ct_share_whatsapp: "Compartilhar no WhatsApp",
            ct_share_twitter: "Compartilhar no X",
            ct_share_copy_link: "Copiar link",
            ct_share_success: "Compartilhado!",
            ct_share_copied: "Link copiado!",
            ct_share_failed: "Não foi possível compartilhar",
            ct_share_section_title: "Compartilhe produtos como no Facebook",
            ct_share_section_subtitle: "Cada produto tem um link único com seu UUID. Envie para qualquer lugar — quem abrir verá a página de detalhes do produto.",
            ct_footer_line: "ComprarTodo — o marketplace onde tudo tem seu lugar.",
            ct_footer_categories_title: "Categorias ousadas",
            ct_footer_categories_desc: "Carros, beleza, eletrônicos, eletrodomésticos, bicicletas, motos, caminhões, plantas, roupas, sapatos e mais.",
            ct_footer_share_hint: "Compartilhe qualquer link de produto com amigos e família.",
            ct_badge_new: "Novo",
            ct_badge_hot: "Popular",
            ct_add_to_cart: "Adicionar ao carrinho",
            ct_share_link_label: "Link compartilhável do produto",
            ct_product_whatsapp: "WhatsApp",
            ct_product_whatsapp_message: "Olá, tenho interesse em {{name}}: {{url}}",
            ct_share_link_hint: "Qualquer pessoa com este link pode ver este produto.",
            ct_related_products: "Você também pode gostar",
            ct_product_not_found: "Produto não encontrado",
            ct_product_not_found_desc: "Este link pode ser inválido ou o produto foi removido.",
            ct_back: "Voltar",
            ct_category_all: "Todos",
            ct_category_cars: "Carros",
            ct_category_beauty: "Beleza",
            ct_category_electronics: "Eletrônicos",
            ct_category_appliances: "Eletrodomésticos",
            ct_category_bicycles: "Bicicletas",
            ct_category_motorcycles: "Motos",
            ct_category_vehicles: "Veículos",
            ct_category_trucks: "Caminhões",
            ct_category_plants: "Plantas",
            ct_category_clothes: "Roupas",
            ct_category_shoes: "Sapatos",
            ct_category_sports: "Esportes",
            ct_category_home: "Casa",
            ct_category_toys: "Brinquedos",
            ct_category_pets: "Pets",
            ct_category_books: "Livros",
            ct_category_jewelry: "Joias",
            ct_category_furniture: "Móveis",
            ct_category_tools: "Ferramentas",
            ct_category_food: "Alimentos",
            ct_product_tesla_name: "Sedã Elétrico Pro 2025",
            ct_product_tesla_desc: "Sedã elétrico premium com mais de 400 milhas de autonomia, assistência autopilot e teto panorâmico. Demo da categoria carros.",
            ct_product_skincare_name: "Kit Skincare de Luxo",
            ct_product_skincare_desc: "Rotina completa de manhã e noite com séruns, hidratante e FPS. Demo da categoria beleza.",
            ct_product_laptop_name: "UltraBook Pro 16\"",
            ct_product_laptop_desc: "Notebook potente com tela OLED, 32GB RAM e bateria para o dia todo. Demo destaque de eletrônicos.",
            ct_product_fridge_name: "Geladeira Smart French Door",
            ct_product_fridge_desc: "Geladeira eficiente com display touch e zonas de resfriamento duplas. Demo de eletrodomésticos.",
            ct_product_bike_name: "Bike Trail Carbono X1",
            ct_product_bike_desc: "Bicicleta de montanha com quadro de carbono leve e freios a disco hidráulicos.",
            ct_product_motorcycle_name: "Cruiser Urbano 900",
            ct_product_motorcycle_desc: "Motocicleta cruiser clássica com motor 900cc e banco de couro. Destaque de motos.",
            ct_product_truck_name: "Pickup Heavy Duty 4x4",
            ct_product_truck_desc: "Caminhonete full-size com pacote de reboque e suspensão off-road. Demo de caminhões.",
            ct_product_plants_name: "Kit Selva Interior",
            ct_product_plants_desc: "Coleção de plantas de interior de baixa manutenção com vasos de cerâmica.",
            ct_product_jacket_name: "Jaqueta All-Weather",
            ct_product_jacket_desc: "Jaqueta impermeável e respirável para uso urbano e outdoor. Clássico de moda.",
            ct_product_sneakers_name: "Air Sprint Runners",
            ct_product_sneakers_desc: "Tênis leve para corrida com amortecimento responsivo. Demo bestseller de sapatos.",
            ct_product_suv_name: "SUV Aventura Familiar",
            ct_product_suv_desc: "SUV espaçoso de 7 lugares com AWD, pacote de segurança e rack de teto.",
            ct_product_sofa_name: "Sofá Modular Lounge",
            ct_product_sofa_desc: "Sofá modular confortável com capas laváveis e assento profundo. Demo de móveis.",

            ct_login_required_cart: "Faça login para adicionar ao carrinho…",
            ct_login_to_buy_hint: "Entre na sua conta para adicionar este produto ao carrinho.",
            ct_login_subtitle: "Entre para comprar, vender e gerenciar sua conta ComprarTodo.",
            ct_signup_title: "Crie sua conta",
            ct_signup_subtitle: "Registre seu negócio e comece a vender no marketplace.",
            ct_signup_step1: "Dados da empresa",
            ct_signup_step2: "Conta",
            ct_signup_progress_label: "Progresso do cadastro",
            ct_signup_next: "Continuar",
            ct_signup_back: "Voltar",
            ct_signup_register: "Registrar",
            ct_signup_have_account: "Já tem uma conta?",
            ct_signup_no_account: "Não tem uma conta?",
            alert_empresa_registrada_correctamente: "Empresa registrada com sucesso.",
            ct_added_to_cart: "Adicionado ao carrinho!",
            ct_price_label: "Preço especial",
            ct_price_sale_label: "Preço promocional",
            ct_price_was: "De",
            ct_discount_off: "{{percent}}% off",
            ct_you_save: "Você economiza",
            ct_trusted_rating: "avaliações verificadas",
            ct_more_photos: "fotos",
            ct_my_account: "Minha conta",
            ct_cart_items: "{{count}} itens no carrinho",
            ct_no_images: "Sem imagens disponíveis",
            ct_gallery_prev: "Imagem anterior",
            ct_gallery_next: "Próxima imagem",
            ct_gallery_go_to: "Ir para imagem",
            ct_gallery_thumbnails: "Fotos do produto",
            ct_angle_front: "Vista frontal",
            ct_angle_side: "Vista lateral",
            ct_angle_back: "Vista traseira",
            ct_angle_detail: "Detalhe",

            icon_all: "Todos",
            icon_food: "Comida",
            icon_tools: "Herramientas",
            icon_furniture: "Mobiliario",
            icon_jewelry: "Joyas",
            icon_pets: "Animales",
            icon_books: "Libros",
            icon_toys: "Juguetes",
            icon_home: "Casa",
            icon_sports: "Deportes",
            icon_shoes: "Zapatos",
            icon_clothes: "Vestimenta",
            icon_plants: "Plantas",
            icon_trucks: "Camiones",
            icon_vehicles: "Vehículos",
            icon_motorcycles: "Motocicletas",
            icon_bicycles: "Bicicletas",
            icon_appliances: "Aparatos",
            icon_electronics: "Electrónica",
            icon_beauty: "Cosmética",
            icon_cars: "Autos",
        },
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: "es",
    fallbackLng: "es",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
